export const BuildInfo = {timestamp:1783380779000}
